import { z } from 'zod';
import { LABEL_COLORS } from '../roles.js';
export const labelColorSchema = z.enum(LABEL_COLORS);
export const createLabelSchema = z.object({
    name: z.string().min(1, 'Name ist Pflicht').max(40),
    color: labelColorSchema,
});
export const patchLabelSchema = z
    .object({
    name: z.string().min(1).max(40).optional(),
    color: labelColorSchema.optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'Keine Aenderung angegeben' });
//# sourceMappingURL=label.js.map